import React from 'react';
import { ArcDroneMarker } from '@src/core/controllers';
import { useFlightProvider } from '@src/features/order/provider';
import { isDroneSignalLost } from '@src/features/drone/utils';
import { SelectedDroneMarkerProps } from './types';

/**
 * Component to render marker for selected drone when it's not on a mission
 */
export const SelectedDroneMarker: React.FC<SelectedDroneMarkerProps> = React.memo(({
  drone,
  onClick,
  isOnMission,
  rotation,
}) => {
  const { gpsInfo, flightData } = useFlightProvider();
  const lost = isDroneSignalLost(drone, gpsInfo, flightData?.serialNumber);

  return (
    isOnMission ? (
      <ArcDroneMarker.missionArrow
        key={drone.id}
        position={{
          lat: Number(drone.latitude),
          lng: Number(drone.longitude),
        }}
        onClick={onClick}
        rotation={rotation}
        lost={lost}
      />
    ) : (
      <ArcDroneMarker.idleArrow
        key={drone.id}
        position={{
          lat: Number(drone.latitude),
          lng: Number(drone.longitude),
        }}
        onClick={onClick}
        lost={lost}
      />
    )
  );
});

SelectedDroneMarker.displayName = 'SelectedDroneMarker';
